import React from "react";
import { IProductDetailsProps } from "~/components/product-details/product-details";
import { Field, reduxForm, InjectedFormProps } from "redux-form";
import InputSelect from "~/components/input-select/input-select";

export interface WorkVariantProps {
    variants: IProductDetailsProps[];
    onVariantSelect: (selectedVariantIndex: string | undefined) => void;
    variantsLabel?: string;
}

interface WorkVariantFormProps {
    selectedVariant: string;
}

type WorkVariantFormPropsUnion = WorkVariantProps & InjectedFormProps<WorkVariantFormProps, WorkVariantProps>;

const WorkVariantSelect: React.FC<WorkVariantFormPropsUnion> = ({ variants, variantsLabel }) => {
    const options = variants
        .filter(({ product }) => product.materialType !== undefined)
        .map(({ product }, index) => ({ label: product.materialType, value: String(index) }));

    return (
        <Field
            className="work-variant-select"
            name="selectedVariant"
            component={InputSelect}
            fieldName="selectedVariant"
            label={variantsLabel}
            options={options}
        />
    );
};

const WorkVariantForm = reduxForm<WorkVariantFormProps, WorkVariantProps>({
    form: "work-variant-form",
    destroyOnUnmount: false,
    onChange: (values, _, props) => {
        const { onVariantSelect, change } = props;

        if (onVariantSelect) {
            onVariantSelect(values.selectedVariant);
        }
        if (change) {
            change("selectedVariant", values.selectedVariant);
        }
    }
})(WorkVariantSelect);

export default WorkVariantForm;
